export const PAGE_SIZE_DEFAULT = {
  pageSize: 20,
  pageSizeSelects: ["20", "50", "70", "100"],
};

export const TIME_COUNT_DOWN = {
  time: 60,
};

export const USERROLE = [
  { key: 1, value: "AGENCY_ADMIN", label: "Đại lý" },
  { key: 2, value: "SUPER_ADMIN", label: "Admin" },
  { key: 3, value: "MODERATOR", label: "Quản trị viên" },
  { key: 4, value: "STORE_USER", label: "Của hàng" },
  { key: 5, value: "NORMAL", label: "Khách hàng" },
  { key: 6, value: "STAFF", label: "Nhân viên hệ thống" },
];

export const CREATEUSER = [
  { key: 2, value: "SUPER_ADMIN", label: "Admin" },
  { key: 6, value: "STAFF", label: "Nhân viên" },
];

export const USERSTATUS = [
  { key: 0, value: 0, label: "Hoạt động" },
  { key: 1, value: 1, label: "Tạm khóa" },
  { key: 2, value: 2, label: "Đã xóa" },
];

export const UPDATEUSERSTATUS = [
  { key: 0, value: 0, label: "Hoạt động" },
  { key: 1, value: 1, label: "Tạm khóa" },
];

export const SIMTYPE = [
  { key: 0, value: "SIM_VAT_LY", label: "Sim vật lý" },
  { key: 1, value: "ESIM", label: "ESIM" },
];

export const TYPESIMKIT = [
  { key: 0, value: 0, label: "Sim Trắng" },
  { key: 1, value: 1, label: "Sim AddKit" },
];

export const SIMMRSTATUS = [
  { key: 0, value: 0, label: "Kích hoạt" },
  { key: 1, value: 1, label: "Tạm khóa" },
  { key: 2, value: 2, label: "Đã xóa" },
];

export const SIMMRRANK = [
  { key: 0, value: "BZONE", label: "BRONZE" },
  { key: 1, value: "QUASI", label: "QUASI" },
  { key: 2, value: "NORMAL", label: "NORMAL" },
  { key: 3, value: "GLOBAL", label: "GLOBAL" },
  { key: 4, value: "SLIVER", label: "SILVER" },
];

export const SIMTELCO = [
  { key: 0, value: "VTL", label: "Viettel" },
  { key: 1, value: "MBF", label: "Mobifone" },
  { key: 2, value: "VNP", label: "Vinaphone" },
  { key: 4, value: "VNM", label: "Vietnamobile" },
];

export const PRICES = [
  { key: 0, value: 5000, label: "5000" },
  { key: 1, value: 10000, label: "10000" },
  { key: 2, value: 20000, label: "20000" },
  { key: 3, value: 30000, label: "30000" },
  { key: 4, value: 50000, label: "50000" },
  { key: 5, value: 100000, label: "100000" },
  { key: 6, value: 200000, label: "200000" },
  { key: 7, value: 300000, label: "300000" },
  { key: 8, value: 500000, label: "500000" },
];

export const SIMTELCODKTTB = [
  { key: 2, value: "GMB", label: "GMobile" },
  { key: 0, value: "VTL", label: "Viettel" },
  { key: 1, value: "MBF", label: "Mobifone" },
  { key: 2, value: "VNP", label: "Vinaphone" },
  { key: 4, value: "VNM", label: "Vietnamobile" },
];

export const TYPEDKTTTB = [
  { key: 1, value: "SINGLE", label: "Đơn lẻ" },
  { key: 2, value: "BULK", label: "Đơn lô" },
];

export const TRANSSTATUS = [
  { key: 1, value: "Pending", label: "Đã đặt" },
  { key: 2, value: "Finished", label: "Thành công" },
  { key: 3, value: "Successed", label: "Đã thanh toán" },
  { key: 4, value: "Failed", label: "Thất bại" },
  { key: 5, value: "Cancelled", label: "Tạm hoãn" },
];

export const TYPETRANS = [{ key: 1, value: 1, label: "Mua sim" }];

export const MRTYPETRANS = [
  { key: 0, value: "NORMAL", label: "Thông thường" },
  { key: 1, value: "PLAN", label: "Gán gói" },
  { key: 2, value: "DKTT", label: "Đăng ký thông tin thuê bao" },
  { key: 3, value: "MOBILE_TOPUP", label: "Nạp tiền" },
  { key: 4, value: "MOBILE_CARD", label: "Thẻ cào" },
  { key: 5, value: "MOBILE_DATA", label: "Dữ liệu di động" },
  { key: 6, value: "PICK_SIM", label: "Chọn số, giữ số" },
];

export const MRTRANS = [
  { key: 0, value: "INIT", label: "Khởi tạo" },
  { key: 1, value: "IN_PROGRESS", label: "Đang xử lý" },
  { key: 2, value: "SUCCESS", label: "Thành công" },
  { key: 3, value: "FAILURE", label: "Lỗi" },
  { key: 4, value: "DELETED", label: "Đã xóa" },
  { key: 5, value: "PENDING", label: "Chờ xử lý" },
];

export const SIMBASESTATUS = [
  { key: 0, value: "INIT", label: "Khởi tạo" },
  { key: 1, value: "WAITING", label: "Đang xử lý" },
  { key: 2, value: "SUBMITTED", label: "Chờ xác nhận" },
  { key: 3, value: "APPROVE", label: "Thành công" },
  { key: 4, value: "REJECT", label: "Lỗi" },
];

export const TRANSTATUS = [
  { key: 0, value: 0, label: "Khởi tạo" },
  { key: 1, value: 1, label: "Đang xử lý" },
  { key: 2, value: 2, label: "Thành công" },
  { key: 3, value: 3, label: "Lỗi" },
  { key: 4, value: 4, label: "Bị từ chối" },
];

export const LIMITCODE = [{ key: 1, value: 1, label: "Billcode" }];

export const LIMITTYPE = [
  { key: 0, value: "NAP_LIMIT", label: "Nạp hạn mức" },
  { key: 1, value: "RUT_LIMIT", label: "Trả hoa hồng" },
  { key: 2, value: "COC_KHO", label: "Bàn giao kho số" },
  { key: 3, value: "CHIET_KHAU", label: "Chiết khấu" },
  { key: 4, value: "HOAN_TIEN", label: "Hoàn tiền" },
];

export const LIMITSTATUS = [
  { key: 3, value: "KHOI_TAO", label: "Khởi tạo" },
  { key: 0, value: "CHO_DUYET", label: "Chờ duyệt" },
  { key: 1, value: "DA_DUYET", label: "Đã duyệt" },
  { key: 2, value: "TU_CHOI", label: "Từ chối" },
];

export const TRANSORDERMRSTATUS = [
  { key: 0, value: 0, label: "Khởi tạo" },
  { key: 1, value: 1, label: "Đang xử lý" },
  { key: 2, value: 2, label: "Thành công" },
  { key: 3, value: 3, label: "Thất bại" },
  { key: 4, value: 4, label: "Đã xóa" },
];

export const TRANSORDERSTATUS = [
  { key: 0, value: "WAITTING", label: "Đang xử lý" },
  { key: 1, value: "SUCCESS", label: "Đã thanh toán" },
  { key: 2, value: "FAILURE", label: "Thất bại" },
  { key: 3, value: "REFUND", label: "Đã hoàn tiền" },
];

export const TRANSTYPE = [
  { key: 1, value: "Sim", label: "Sim" },
  { key: 2, value: "Package", label: "Gói" },
  { key: 3, value: "Topup", label: "Gói cước" },
  { key: 4, value: "Card", label: "Thẻ nạp" },
];

export const ORDERTYPE = [
  { key: 1, value: "SIM_VAT_LY", label: "Sim vật lý" },
  { key: 2, value: "ESIM", label: "Esim" },
];

export const TYPEDKTTB = [{ key: 1, value: 1, label: "Tứ quý" }];

export const TYPESIMDKTTB = [
  { key: 1, value: "SIM_VAT_LY", label: "Sim vật lý" },
  { key: 2, value: "ESIM", label: "Esim" },
];

export const GENDER = [
  { key: 0, value: "MALE", label: "Nam" },
  { key: 1, value: "FEMALE", label: "Nữ" },
];

export const ADDPACSTATUS = [
  { key: 1, value: "1", label: "Thành công" },
  { key: 2, value: "2", label: "Đã hủy" },
  { key: 3, value: "3", label: "Chờ duyệt đơn hàng" },
  { key: 4, value: "4", label: "Thành công một phần" },
];

export const TOPUPORDERTYPE = [
  { key: 3, value: "MOBILE_TOPUP", label: "Nạp tiền điện thoại" },
  { key: 4, value: "MOBILE_CARD", label: "Mua thẻ nạp" },
];

export const TOPUPORDERSTATUS = [
  { key: 1, value: 1, label: "Thành công" },
  { key: 2, value: 2, label: "Không thành công" },
];

export const TYPEIN = [
  { key: 1, value: 1, label: "Thêm mới" },
  { key: 2, value: 2, label: "Điều chỉnh" },
];

export const STATUSIMEMBRYO = [
  { key: 1, value: 1, label: "Đã đăng ký" },
  { key: 2, value: 2, label: "Chưa đăng ký" },
];

export const STATUSIMADDEMBRYO = [
  { key: 0, value: "INIT", label: "Khởi tạo" },
  { key: 1, value: "WAITING", label: "Đang xử lý" },
  { key: 2, value: "APPROVE", label: "Thành công" },
  { key: 3, value: "SUBMITTED", label: "Chờ xác nhận" },
  { key: 4, value: "REJECT", label: "Thất bại" },
];

export const PACMRSTATUS = [
  { key: 0, value: 0, label: "Hoạt động " },
  { key: 1, value: 1, label: "Tạm khóa" },
  { key: 2, value: 2, label: "Đang xử lý" },
];

export const DATATYPE = [
  { key: 0, value: "DAILY", label: "Gói ngày" },
  { key: 1, value: "WEEKLY", label: "Gói tuần" },
  { key: 2, value: "MONTHLY", label: "Gói tháng" },
  { key: 3, value: "YEARLY", label: "Gói năm" },
];

export const PACMRTYPE = [
  { key: 0, value: "NORMAL", label: "NORMAL" },
  { key: 1, value: "ONLY_DATA", label: "ONLY_DATA" },
  { key: 2, value: "ROAMING", label: "ROAMING" },
];

export const TYPEGTTT = [
  { key: 0, value: "CCCD", label: "CCCD" },
  { key: 1, value: "CAN_CUOC", label: "Căn cước" },
];

export const TYPESIM = [
  { key: 1, value: "SIM_VAT_LY", label: "Sim vật lý" },
  { key: 2, value: "ESIM", label: "Esim" },
];

export const STATUSDKTTB = [
  { key: 0, value: "INIT", label: "Khởi tạo" },
  { key: 1, value: "WAITING", label: "Đang xử lý" },
  { key: 2, value: "SUBMITTED", label: "Chờ xác nhận" },
  { key: 3, value: "APPROVE", label: "Thành công" },
  { key: 4, value: "REJECT", label: "Từ chối" },
];

export const STATUSNEGO = [
  { key: 0, value: "INIT", label: "Chờ xử lý" },
  { key: 1, value: "APPROVE", label: "Đã duyệt" },
  { key: 2, value: "REJECT", label: "Từ chối" },
];

export const MRSTATUS = [
  { key: 0, value: "ACTIVE", label: "Hoạt động" },
  { key: 1, value: "INACTIVE", label: "Không hoạt động" },
  { key: 2, value: "DELETED", label: "Đã xóa" },
  { key: 3, value: "PENDING", label: "Chờ duyệt" },
  { key: 4, value: "DENY", label: "Từ chối" },
];

export const ROSESTATUS = [
  { key: 1, value: 1, label: "Xác nhận" },
  { key: 2, value: 2, label: "Hủy" },
  { key: 3, value: 3, label: "Thành công" },
];

export const DASHBOARD = [
  { key: 0, value: 0, label: "Kênh bán 1" },
  { key: 1, value: 1, label: "Kênh bán 2" },
];

export const LOGSTYPE = [
  { key: 0, value: "START", label: "START" },
  { key: 1, value: "REGISTER_MOBILE", label: "REGISTER_MOBILE" },
  { key: 2, value: "ADD_KIT", label: "ADD_KIT" },
  { key: 3, value: "CARD_EKYC", label: "CARD_EKYC" },
  { key: 4, value: "CONFIRM_EKYC", label: "CONFIRM_EKYC" },
  { key: 5, value: "SELFIE_EKYC", label: "SELFIE_EKYC" },
  { key: 6, value: "FILL_FORM", label: "FILL_FORM" },
  { key: 7, value: "SIGNATURE_EKYC", label: "SIGNATURE_EKYC" },
];

export const TYPETOPUP = [
  { key: 0, value: 0, label: "Hoạt động" },
  { key: 1, value: 1, label: "Không hoạt động" },
  { key: 2, value: 2, label: "Đã xóa" },
];

export const TYPEDISCOUNT = [
  { key: 2, value: 2, label: "%/Giao dịch" },
  { key: 1, value: 1, label: "VNĐ/Giao dịch" },
];

export const DiscountProductType = [
  { key: 1, value: "TOP_UP", label: "Topup" },
  { key: 2, value: "DATA", label: "Data" },
  { key: 3, value: "CARD", label: "Thẻ cào" },
];

export const SIMKITPICKSTATUS = [
  { key: 0, value: 0, label: "Đang xử lý" },
  { key: 1, value: 1, label: "Đang giữ số" },
  { key: 2, value: 2, label: "Đã chuyển nhượng" },
  { key: 3, value: 3, label: "Đã đăng ký" },
  { key: 4, value: 4, label: "Từ chối" },
];

export const SIMPREMIUMSTATUS = [
  { key: 0, value: "WAITING", label: "Đang xử lý" },
  { key: 1, value: "PICKED", label: "Đang giữ số" },
  { key: 2, value: "TRANSFERRED", label: "Đã chuyển nhượng" },
  { key: 3, value: "REGISTERED", label: "Đã đăng ký" },
  { key: 4, value: "REJECT", label: "Hết hạn giữ số" },
  { key: 5, value: "DEPOSITED", label: "Đặt cọc" },
  { key: 6, value: "PAID", label: "Thanh toán" },
  { key: 7, value: "NEGOTIATING", label: "Đang thương lượng" },
  { key: 8, value: "NEGOTIATION_APPROVED", label: "Thương lượng thành công" },
  { key: 9, value: "NEGOTIATION_REJECTED", label: "Thương lượng thất bại" },
];

export const HISTORYNEOSTATUS = [
  { key: 0, value: "INIT", label: "Khởi tạo" },
  { key: 1, value: "APPROVED", label: "Đã duyệt" },
  { key: 2, value: "REJECTED", label: "Từ chối" },
];
